// src/pages/Wallet/components/PriceChange.js
import React, { useEffect, useState } from 'react';
import { BsArrowUpRight, BsArrowDownRight, BsDash } from 'react-icons/bs';

/**
 * Component to display price change percentage with appropriate styling
 * @param {Object} props
 * @param {Array} props.data - Chart data to calculate price change from
 * @param {number} props.staticValue - Static price change value if data is not provided
 * @param {string} props.className - Additional CSS class
 * @param {Object} props.style - Additional inline styles
 */
const PriceChange = ({ data, staticValue, className = '', style = {} }) => {
  const [priceChange, setPriceChange] = useState(null);
  
  useEffect(() => {
    // Calculate price change from data if available
    if (data && data.length >= 2) {
      const firstPrice = data[0].price || data[0].close;
      const lastPrice = data[data.length - 1].price || data[data.length - 1].close;
      const change = ((lastPrice - firstPrice) / firstPrice) * 100;
      setPriceChange(change);
    } else if (staticValue !== undefined && staticValue !== null) {
      // Use static value if provided
      setPriceChange(staticValue);
    } else {
      setPriceChange(null);
    }
  }, [data, staticValue]);
  
  if (priceChange === null) {
    return (
      <span className={`price-change neutral ${className}`} style={style}>
        <BsDash className="price-change-icon" /> --
      </span>
    );
  }
  
  const isPositive = priceChange >= 0;
  const formattedChange = Math.abs(priceChange).toFixed(2);
  
  return (
    <span 
      className={`price-change ${isPositive ? 'positive' : 'negative'} ${className}`}
      style={style}
    >
      {isPositive ? (
        <>
          <BsArrowUpRight className="price-change-icon" /> +{formattedChange}%
        </>
      ) : (
        <>
          <BsArrowDownRight className="price-change-icon" /> -{formattedChange}%
        </>
      )}
    </span>
  );
};

export default PriceChange;